module.exports = __webpack_public_path__ + "statics/img/cate4-5@2x.6c9b5653.png";